import { writable } from 'svelte/store';

export const modalOpen = writable(false);

export function openModal() {
    modalOpen.set(true);
    if (typeof document !== 'undefined') {
        document.body.style.overflow = 'hidden';
    }
}

export function closeModal() {
    modalOpen.set(false);
    if (typeof document !== 'undefined') {
        document.body.style.overflow = '';
    }
}
